import type { ReactNode } from 'react';
import { SWS_HOST } from '@/constants';
import UniversalLink from '@components/UniversalLink';

const PlatformArticleLink = ({
  slug,
  canonicalUrl,
  children,
  onClick,
}: {
  slug: string;
  canonicalUrl: string;
  children: ReactNode;
  onClick: () => void;
}) => {
  const path = SWS_ENV === 'prod' ? canonicalUrl : `/article/${slug}`;
  return (
    <UniversalLink onClick={onClick} to={path}>
      {children}
    </UniversalLink>
  );
};

const NewsArticleLink = ({
  slug,
  canonicalUrl,
  children,
  onClick,
}: {
  slug: string;
  canonicalUrl: string;
  children: ReactNode;
  onClick: () => void;
}) => {
  let fullUrl;
  switch (SWS_ENV) {
    case 'prod':
      fullUrl = `${SWS_HOST}${canonicalUrl}`;
      break;
    case 'staging':
      fullUrl = `https://staging.simplywall.st/${canonicalUrl}`;
      break;
    default:
      fullUrl = `https://news-stable.dev.simplywall.st/article/${slug}`;
      break;
  }

  return (
    <UniversalLink onClick={onClick} to={fullUrl}>
      {children}
    </UniversalLink>
  );
};

export { PlatformArticleLink, NewsArticleLink };
